import Tool, {
  type IToolActionInput,
  type IToolEnabledInput,
  simpleToolButton,
} from './Tool';
import { hasRecordReference } from '../objects/guards';

class ToolWatchClip extends Tool {
  static toolName = 'Watch clip';

  static available({ selection }: IToolEnabledInput): boolean {
    if (!selection || !hasRecordReference(selection)) {
      return false;
    }

    const record = selection.shape.recordInfo;
    return !!(
      record &&
      record.typename === 'Annotation' &&
      record.id &&
      record.type === 'CLIP'
    );
  }

  static async action({ selection, controller }: IToolActionInput) {
    if (!hasRecordReference(selection)) {
      return;
    }

    const record = selection.shape.recordInfo;
    if (
      !record ||
      record.typename !== 'Annotation' ||
      !record.id ||
      record.type !== 'CLIP'
    ) {
      return;
    }

    if (typeof controller.props.openAnnotationClip === 'function') {
      try {
        controller.props.openAnnotationClip(record.id);
      } catch (error) {
        console.error('Failed to open watch clip modal:', error);
      }
    }
  }

  static enabled(args: IToolEnabledInput) {
    return ToolWatchClip.available(args);
  }

  static buttonComponent() {
    return simpleToolButton(ToolWatchClip, 'fa-regular fa-play', {
      stopPropagation: true,
    });
  }
}

export default ToolWatchClip;
